export default "__VITE_ASSET__Bz4R9ltT__"